
export const NEW_CONTROLE_PRAGA_DOENCA = 'NEW_CONTROLE_PRAGA_DOENCA'
export const NEW_CONTROLE_PRAGA_DOENCA_SUCCESS = 'NEW_CONTROLE_PRAGA_DOENCA_SUCCESS'

export const CREATE_CONTROLE_PRAGA_DOENCA = 'CREATE_CONTROLE_PRAGA_DOENCA'
export const CREATE_CONTROLE_PRAGA_DOENCA_PENDING = 'CREATE_CONTROLE_PRAGA_DOENCA_PENDING'
export const CREATE_CONTROLE_PRAGA_DOENCA_SUCCESS = 'CREATE_CONTROLE_PRAGA_DOENCA_SUCCESS'
export const CREATE_CONTROLE_PRAGA_DOENCA_FAILURE = 'CREATE_CONTROLE_PRAGA_DOENCA_FAILURE'

export const TABLE_CONTROLE_PRAGA_DOENCA = 'TABLE_CONTROLE_PRAGA_DOENCA'
export const TABLE_CONTROLE_PRAGA_DOENCA_PENDING = 'TABLE_CONTROLE_PRAGA_DOENCA_PENDING'
export const TABLE_CONTROLE_PRAGA_DOENCA_SUCCESS = 'TABLE_CONTROLE_PRAGA_DOENCA_SUCCESS'
export const TABLE_CONTROLE_PRAGA_DOENCA_FAILURE = 'TABLE_CONTROLE_PRAGA_DOENCA_FAILURE'

export const LIST_CONTROLE_PRAGA_DOENCA = 'LIST_CONTROLE_PRAGA_DOENCA'
export const LIST_CONTROLE_PRAGA_DOENCA_PENDING = 'LIST_CONTROLE_PRAGA_DOENCA_PENDING'
export const LIST_CONTROLE_PRAGA_DOENCA_SUCCESS = 'LIST_CONTROLE_PRAGA_DOENCA_SUCCESS'
export const LIST_CONTROLE_PRAGA_DOENCA_FAILURE = 'LIST_CONTROLE_PRAGA_DOENCA_FAILURE'

export const FIND_CONTROLE_PRAGA_DOENCA = 'FIND_CONTROLE_PRAGA_DOENCA'
export const FIND_CONTROLE_PRAGA_DOENCA_PENDING = 'FIND_CONTROLE_PRAGA_DOENCA_PENDING'
export const FIND_CONTROLE_PRAGA_DOENCA_SUCCESS = 'FIND_CONTROLE_PRAGA_DOENCA_SUCCESS'
export const FIND_CONTROLE_PRAGA_DOENCA_FAILURE = 'FIND_CONTROLE_PRAGA_DOENCA_FAILURE'

export const DELETE_CONTROLE_PRAGA_DOENCA = 'DELETE_CONTROLE_PRAGA_DOENCA'
export const DELETE_CONTROLE_PRAGA_DOENCA_PENDING = 'DELETE_CONTROLE_PRAGA_DOENCA_PENDING'
export const DELETE_CONTROLE_PRAGA_DOENCA_SUCCESS = 'DELETE_CONTROLE_PRAGA_DOENCA_SUCCESS'
export const DELETE_CONTROLE_PRAGA_DOENCA_FAILURE = 'DELETE_CONTROLE_PRAGA_DOENCA_FAILURE'

export const NEW_FILTER_CONTROLE_PRAGA_DOENCA = 'NEW_FILTER_CONTROLE_PRAGA_DOENCA'
export const NEW_FILTER_CONTROLE_PRAGA_DOENCA_PENDING = 'NEW_FILTER_CONTROLE_PRAGA_DOENCA_PENDING'
export const NEW_FILTER_CONTROLE_PRAGA_DOENCA_SUCCESS = 'NEW_FILTER_CONTROLE_PRAGA_DOENCA_SUCCESS'
export const NEW_FILTER_CONTROLE_PRAGA_DOENCA_FAILURE = 'NEW_FILTER_CONTROLE_PRAGA_DOENCA_FAILURE'

export const NEW_FILTER_NEXT_PAGE_CONTROLE_PRAGA_DOENCA = 'NEW_FILTER_NEXT_PAGE_CONTROLE_PRAGA_DOENCA'
export const NEW_FILTER_NEXT_PAGE_CONTROLE_PRAGA_DOENCA_PENDING = 'NEW_FILTER_NEXT_PAGE_CONTROLE_PRAGA_DOENCA_PENDING'
export const NEW_FILTER_NEXT_PAGE_CONTROLE_PRAGA_DOENCA_SUCCESS = 'NEW_FILTER_NEXT_PAGE_CONTROLE_PRAGA_DOENCA_SUCCESS'
export const NEW_FILTER_NEXT_PAGE_CONTROLE_PRAGA_DOENCA_FAILURE = 'NEW_FILTER_NEXT_PAGE_CONTROLE_PRAGA_DOENCA_FAILURE'

export const MARCAR_TRATADO_CONTROLE_PRAGA_DOENCA = 'MARCAR_TRATADO_CONTROLE_PRAGA_DOENCA'
export const MARCAR_TRATADO_CONTROLE_PRAGA_DOENCA_PENDING = 'MARCAR_TRATADO_CONTROLE_PRAGA_DOENCA_PENDING'
export const MARCAR_TRATADO_CONTROLE_PRAGA_DOENCA_SUCCESS = 'MARCAR_TRATADO_CONTROLE_PRAGA_DOENCA_SUCCESS'
export const MARCAR_TRATADO_CONTROLE_PRAGA_DOENCA_FAILURE = 'MARCAR_TRATADO_CONTROLE_PRAGA_DOENCA_FAILURE'

export const MARCAR_CANCELADO_CONTROLE_PRAGA_DOENCA = 'MARCAR_CANCELADO_CONTROLE_PRAGA_DOENCA'
export const MARCAR_CANCELADO_CONTROLE_PRAGA_DOENCA_PENDING = 'MARCAR_CANCELADO_CONTROLE_PRAGA_DOENCA_PENDING'
export const MARCAR_CANCELADO_CONTROLE_PRAGA_DOENCA_SUCCESS = 'MARCAR_CANCELADO_CONTROLE_PRAGA_DOENCA_SUCCESS'
export const MARCAR_CANCELADO_CONTROLE_PRAGA_DOENCA_FAILURE = 'MARCAR_CANCELADO_CONTROLE_PRAGA_DOENCA_FAILURE'
